import React, { memo, useEffect, useMemo, useState } from 'react';
import { Menu } from 'antd';
import DropDown from '@/components/common/dropdown';
import { useSelector } from 'react-redux';
import { withRouter } from 'react-router-dom';

import './style.scss';
import { autoSetXBusinessGuid, getXBusinessGuid, setXBusinessGuid } from '@/utils/business';
import { CaretDownOutlined } from '@ant-design/icons';
import configs from '@/config';

const ActiveBusinessSelector = ({}) => {
  const [selectedItem, setSelectedItem] = useState(getXBusinessGuid());
  const { user, userBusinesses } = useSelector((state) => state.authenticate);

  const selectedBusiness = useMemo(
    () => userBusinesses?.find((_) => _.guid === selectedItem)?.name || '',
    [selectedItem, userBusinesses],
  );

  useEffect(() => {
    if (user && userBusinesses.length) {
      const { last_business_guid, preferred_business_guid } = user || {};
      const guid = autoSetXBusinessGuid(
        last_business_guid,
        preferred_business_guid,
        userBusinesses || [],
      );
      if (guid) setSelectedItem(guid);
    }
  }, [user, userBusinesses]);

  const onItemClicked = (item) => () => {
    setSelectedItem(item?.guid);
    setXBusinessGuid(item?.guid);
    setTimeout(() => {
      window.location.reload(false);
    }, 0);
  };

  const renderDropDownList = () => (
    <Menu>
      {userBusinesses.map((item) => (
        <Menu.Item key={`${item.guid}`} onClick={onItemClicked(item)}>
          {item.name}
        </Menu.Item>
      ))}
    </Menu>
  );

  if (userBusinesses.length === 0 || configs.enabledComponents !== 'all') return null;

  return (
    <DropDown menu={renderDropDownList}>
      <div className="search-box-container">
        <p className="text-select-business">{selectedBusiness || 'Select Business'}</p>
        <CaretDownOutlined />
      </div>
    </DropDown>
  );
};

export default memo(withRouter(ActiveBusinessSelector));
